const playClickSpecial = (gobackSound) => {
  let audio;
  if (gobackSound === true) {
    audio = new Audio(`${process.env.PUBLIC_URL}/assets/sounds/goback_sound.mp3`);
  } else {
    audio = new Audio(`${process.env.PUBLIC_URL}/assets/sounds/click_sound.mp3`);
  }
  audio.play();
};

export default playClickSpecial;